import { handleNetworkError, showSuccessToast } from '../../utils';
import formatDate from 'date-fns/format';
import { persistTransaction, setTransactionApproved, setTransactionRejected, fetchBankTransactions, persistBankTransaction, setBankTransactionApproved, setBankTransactionRejected, fetchDepositTransactions, fetchTransactionLogs } from '../../services/API';
import router from '../../router';

export const getTransactions = async ({ commit }, page = 1) => {
  commit('FETCHING_TRANSACTIONS', true);

  try {
    let {data, pagination} = await fetchDepositTransactions(page);
    data = data.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
      .map(transaction => {
        if(transaction.accountTransactions && transaction.accountTransactions.length){
          const accountTransactionDetails = transaction.accountTransactions[0];
          if(accountTransactionDetails){
            let { fromAccount, toAccount, fromExternalAccount, toExternalAccount } = accountTransactionDetails;
            if(!accountTransactionDetails.fromExternalAccount){
              if(transaction.accountTransactions.length > 1 && transaction.accountTransactions[1].fromExternalAccount)
                fromExternalAccount = transaction.accountTransactions[1].fromExternalAccount;
              else
                fromExternalAccount = transaction.fromExternalAccount;
            }
              
            transaction = {
              ...transaction, fromAccount, toAccount, fromExternalAccount, toExternalAccount
            }
          }
        }
        
        const date = transaction.paidAt ? transaction.paidAt : transaction.updatedAt;
        transaction.date = formatDate(date, 'Do MMM YYYY');
        transaction.time = formatDate(date, 'HH:mm');

        return transaction;
      })
      .filter(transaction => transaction.amount > 0 && transaction.createdAt);

    commit('FETCHING_TRANSACTIONS', false);
    commit('SET_TRANSACTIONS', {data, pagination});
  } catch (error) {
    commit('FETCHING_TRANSACTIONS', false);
    handleNetworkError(error, "Error fetching deposits:");
  }
}

export const createTransaction = async ({ state, commit }, data) => {
  commit('CREATING_TRANSACTION', true);

  try {
    const transaction = await persistTransaction(data);
    const date = transaction.paidAt ? transaction.paidAt : transaction.updatedAt;
    transaction.date = formatDate(date, 'Do MMM YYYY');
    transaction.time = formatDate(date, 'HH:mm');
    commit('CREATING_TRANSACTION', false);
    let transactions = state.transactions || [];

    transactions.unshift(transaction);

    commit('SET_TRANSACTIONS', {data: transactions});
    showSuccessToast("Transaction created");
    router.replace('/deposits');
  } catch (error) {
    commit('CREATING_TRANSACTION', false);
    handleNetworkError(error, "Error creating transaction:");
  }
}

export const approveTransaction = async ({commit}, transactionId) => {
  try {
    commit('UPDATE_TRANSACTION', {transactionId, changes: {approving: true}});
    await setTransactionApproved(transactionId);
    const changes = {approving: false, approvalStatus: 1, paidAt: new Date()};
    commit('UPDATE_TRANSACTION', {transactionId, changes});
    showSuccessToast("Transaction approved");
  } catch (error) {
    commit('UPDATE_TRANSACTION', {transactionId, changes: {approving: false}});
    handleNetworkError(error, "Error approving transaction:");
  }
}

export const rejectTransaction = async ({commit}, {transactionId, remark}) => {
  try {
    commit('UPDATE_TRANSACTION', {transactionId, changes: {rejecting: true}});
    await setTransactionRejected(transactionId, remark);
    const changes = {rejecting: false, approvalStatus: 2};
    commit('UPDATE_TRANSACTION', {transactionId, changes});
    showSuccessToast("Transaction rejected");
  } catch (error) {
    commit('UPDATE_TRANSACTION', {transactionId, changes: {rejecting: false}});
    handleNetworkError(error, "Error rejecting transaction:");
  }
}

export const getTransactionLogs = async ({ commit }, {page, filter}) => {
  commit('FETCHING_TRANSACTION_LOGS', true);
  page = page || 1;
  filter = filter || "";

  if(filter === "All")
      filter = "";
  else{
      filter = filter.replace(/\s+/g, '');
      filter = filter.toLowerCase();
  }

  try {
    let {data, pagination} = await fetchTransactionLogs(page, filter);
    
    data = data.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
      .map(transaction => {
        if(transaction.accountTransactions && transaction.accountTransactions.length){
          const accountTransactionDetails = transaction.accountTransactions[0];
          if(accountTransactionDetails){
            let { fromAccount, toAccount, fromExternalAccount, toExternalAccount } = accountTransactionDetails;
            if(!accountTransactionDetails.fromExternalAccount){
              if(transaction.accountTransactions.length > 1 && transaction.accountTransactions[1].fromExternalAccount)
                fromExternalAccount = transaction.accountTransactions[1].fromExternalAccount;
              else
                fromExternalAccount = transaction.fromExternalAccount;
            }
              
            transaction = {
              ...transaction, fromAccount, toAccount, fromExternalAccount, toExternalAccount
            }
          }
        }

        const date = transaction.paidAt ? transaction.paidAt : transaction.updatedAt;
        transaction.date = formatDate(date, 'Do MMM YYYY');
        transaction.time = formatDate(date, 'HH:mm');

        return transaction;
      });

    commit('FETCHING_TRANSACTION_LOGS', false);
    commit('SET_TRANSACTION_LOGS', {data, pagination});
  } catch (error) {
    commit('FETCHING_TRANSACTION_LOGS', false);
    handleNetworkError(error, "Error fetching transactions:");
  }
}

export const setTransactionTypeFilter = ({ commit }, filter) => {
  commit('SET_TRANSACTION_TYPE_FILTER', filter);
}



export const getBankTransactions = async ({ commit }) => {
  commit('FETCHING_BANK_TRANSACTIONS', true);

  try {
    let response = await fetchBankTransactions();
    if(!response.data)
      response = {data: response};

    const transactions = response.data
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
      .map(transaction => {
        if(transaction.paidAt)
          transaction.date = formatDate(new Date(transaction.paidAt), 'Do MMM YYYY');

        if(transaction.type === "deposit")
          transaction.type = "investment"

        return transaction;
      })
      .filter(transaction => transaction.amount > 0 && transaction.createdAt);

    commit('FETCHING_BANK_TRANSACTIONS', false);
    commit('SET_BANK_TRANSACTIONS', transactions);
  } catch (error) {
    commit('FETCHING_BANK_TRANSACTIONS', false);
    handleNetworkError(error, "Error fetching transactions:");
  }
}

export const createBankTransaction = async ({ state, commit }, data) => {
  commit('CREATING_BANK_TRANSACTION', true);

  try {
    const response = await persistBankTransaction(data);
    commit('CREATING_BANK_TRANSACTION', false);
    let bankTransactions = state.bankTransactions || [];

    bankTransactions.unshift(response.data);

    commit('SET_BANK_TRANSACTIONS', bankTransactions);
    showSuccessToast("Bank transaction created");
    router.replace('/bankTransactions');
  } catch (error) {
    commit('CREATING_BANK_TRANSACTION', false);
    handleNetworkError(error, "Error creating transaction:");
  }
}

export const approveBankTransaction = async ({commit}, transactionId) => {
  try {
    commit('UPDATE_BANK_TRANSACTION', {transactionId, changes: {approving: true}});
    await setBankTransactionApproved(transactionId);
    const changes = {approving: false, checkerApprovalStatus: 1, paidAt: new Date()};
    commit('UPDATE_BANK_TRANSACTION', {transactionId, changes});
  } catch (error) {
    commit('UPDATE_BANK_TRANSACTION', {transactionId, changes: {approving: false}});
    handleNetworkError(error, "Error approving transaction:");
  }
}

export const rejectBankTransaction = async ({commit}, {transactionId, remark}) => {
  try {
    commit('UPDATE_BANK_TRANSACTION', {transactionId, changes: {rejecting: true}});
    await setBankTransactionRejected(transactionId, remark);
    const changes = {rejecting: false, checkerApprovalStatus: 2};
    commit('UPDATE_BANK_TRANSACTION', {transactionId, changes});
  } catch (error) {
    commit('UPDATE_BANK_TRANSACTION', {transactionId, changes: {rejecting: false}});
    handleNetworkError(error, "Error rejecting transaction:");
  }
}
